<template lang="pug">
  #theBishop
    v-card(width="100%" height="335",dark)
      v-img(src="../../assets/img/stainGlass.png" height="100%"  )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            .display-2.font-weight-black.bishop-title.warning Bishop Yvette A. Flunder
    v-container
      v-row()
        v-col(cols="12")
          v-img.float-sm-left.mr-8.mb-8(src="../../assets/img/people/BishopFlunder.jpg" width="300" )
          p Trying to establish a relationship with a God that barely tolerates you but cannot truly accept and certainly will never celebrate you can do incredible damage to one's self esteem. The tortured historical and theological view that suggests that some people are just flawed or born to be the underclass and should never expect to be on God’s ‘A’ list, has been the convenient method used to hold women, immigrants, the poor and LGBT people in chains of self-depreciation.
          p We all need community. When access to existing communities is not available, marginalized people must seek to develop community for and among themselves. We at City of Refuge UCC are giving birth to a fresh, emerging Christian community. We believe that now, as in the time of Jesus’ earthly ministry, seemingly marginalized people respond to a community of openness and inclusivity, where other people from the edge gather. City of Refuge UCC welcomes people to be who they are by embracing a theology of acceptance      – a radical inclusivity that leaves no one behind.

          p Welcome Home!
          p Rev., Dr. Y. A. Flunder
      v-row(justify="center")
        v-col(cols="12")
          v-card.pa-4 
            .display-1(color="primary" ) About Bishop Flunder
            v-row
              v-col(cols="12")
                v-img.ma-2.float-right(src="../../assets/img/people/AboutFlunder.jpg" width="300" )
                p.body-1 Bishop Yvette Flunder is a native San Franciscan and third generation preacher with roots in the Church of God in Christ. Bishop Flunder is an ordained minister of the United Church of Christ and holds both masters and doctorate degrees in Ministry from the Pacific School of Religion and the San Francisco Theological Seminary, respectively. In 2003, she was appointed Presiding Bishop of The Fellowship of Affirming Ministries, a multi-denominational coalition of over 56 churches and faith-based organizations from all over the world.
                p.body-1 Bishop Flunder is a trustee and adjunct professor at the Pacific School of Religion in Berkeley, California. She is an active voice for the Religion Council of the Human Rights Campaign, as well as for the National Black Justice Coalition. Bishop Flunder is a highly sought after preacher and religious educator as evidenced by her having spoken at divinity schools nationwide including those at Duke, Yale , Drew, and the New York Theological Seminary. She is the author of Where the Edge Gathers: A Theology of Homiletic Radical Inclusion, published by Pilgrim Press. In addition to her memorable sermons, Bishop Flunder is also known for her beautiful singing voice, made famous through her gospel recordings with Walter Hawkins and the Family, the City of Refuge Choir and Chanticleer.

                  .body-1 Read more HERE for Bishop Flunder's complete Biography.
      v-row(justify="start")
        v-col(cols="12" md="4" align="center")
          .title.mb-1 Pictures of Bishop Flunder
          div(style="max-width:300px")            
            v-carousel(cycle height='400' delimiter-icon="mdi-circle-medium" hide-delimiter-background show-arrows-on-hover)
              v-carousel-item(v-for="(photo,i) in photos" :key="i" :src="photo", 'reverse-transition'="fade-transition" transition="fade-transition")
        v-col(cols="12" md="8" align="center")
          .display-1 Download Bishop's CV
          .headline.d-block.my-3 
            a(href="#") Bishop Flunder's Work responding to the AIDS epidemic 
          .headline.d-block.my-3 
            a(href="#") YA Flunder Organization
          .headline.d-block.my-3 
            a(href="#") TFAM &mdash; The Fellowship of Affirming Ministries
          .headline.d-block.my-3 
            a(href="#") Craft of Preaching TFAM &mdash; Working Preacher Series, Luther Seminary
          .headline.d-block.my-3 
            a(href="#") Reclaiming Love Video

                
                
</template>

<script>
export default {
  data() {
    return {
      photo: require('../../assets/img/people/Flunder_1.jpeg'),
      photos: [
        {
          src: require('../../assets/img/people/Flunder_1.jpeg')
        },
        {
          src: require('../../assets/img/people/Flunder_2.jpg')
        },
        {
          src: require('../../assets/img/people/Flunder_3.jpg')
        },
        {
          src: require('../../assets/img/people/Flunder_4.jpg')
        },
        {
          src: require('../../assets/img/people/Flunder_5.jpg')
        }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
.bishop-title
  font-family Cardo, 'san-serif' !important
  line-height 65px
  color var(--v-primary-base)
</style>
